<template>
    <div class="container-fluid">
        <div class="herosection">
            <NavbarSection />
        </div>
        <div class="img-container">
            <div class="heroWriteup">
                <h2>Social Events</h2>
                <p v-html="description"></p>
            </div>
            <div  class="imgsection">
                <img :src="image ? image : require('../assets/images/events/event.jpg')" alt="">
            </div>
        </div>
        <div class="container">
            <div
                v-for="(item, index) in dataList"
                :key="item.id"
                class="event-card"
                >
                <!-- Accordion Header -->
                <div class="event-header mb-1" @click="toggleAccordion(index)">
                    <h2>{{ item.types }}</h2>
                    <span class="arrow" :class="{ open: openIndex === index }">&#9660;</span>
                </div>

                <!-- Accordion Body -->
                <transition name="accordion">
                    <div v-if="openIndex === index" class="event-content">
                    
                    <!-- If index is even -->
                    <div v-if="index % 2 === 0" class="event-card-content">
                        <div class="blog-content p-4">
                        <h4>{{ item.title }}</h4>
                        <p v-html="item.description"></p>
                        </div>
                        <div class="blog-img">
                        <img :src="base_url + item.banner_image" alt="">
                        </div>
                    </div>

                    <!-- If index is odd -->
                    <div v-else class="event-card-content">
                        <div class="blog-img">
                        <img :src="base_url + item.banner_image" alt="">
                        </div>
                        <div class="blog-content p-4">
                            <h4>{{ item.title }}</h4>
                        <p v-html="item.description"></p>
                        </div>
                    </div>

                    </div>
                </transition>

            </div>

            <div v-if="advertList.length > 0" style="font-size: 30px; font-weight: bold;  font-family:Comic Sans MS;">ADVERTS</div>
            <div class="advert-grid">
                <div
                    v-for="(item, index) in advertList"
                    :key="index"
                    class="advert-card"
                >
                    <!-- Fixed Size Banner -->
                    <div class="banner">
                        <img 
                            :src="base_url + item.banner_image" 
                            :alt="item.title"
                        >
                    </div>

                    <!-- Content Area -->
                    <div class="content">
                        <h3 class="title">{{ item.title }}</h3>
                        <p class="description" v-html="item.description"></p>
                        <p class="website"><a :href="'https://'+item.website" target="_blank">{{ item.website }}</a></p>
                    </div>
                </div>
            </div>
        </div>
    <FooterSection />
</div>
</template>

<script setup>
    /* eslint-disable */
import FooterSection from '@/components/FooterSection.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import { ref, onMounted } from "vue"
import axios from 'axios';

const dataList = ref([]);
const advertList = ref([])
const openIndex = ref(null)
let base_url = process.env.VUE_APP_BASE_LIVE_URL

const bannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');

onMounted( async () => {
  await listRecords();
  await listAdverts();
  await listBanner()
});

// Fetch records
const listRecords = async () => {
  try {
    const response = await axios.get("/event_public_lists.php");
    dataList.value = response.data.data
  } catch (error) {
    console.error(error.message);
  }
};

const listAdverts = async () => {
  try {
    const response = await axios.get("/advert_list.php");
    advertList.value = response.data.data
  } catch (error) {
    console.error(error.message);
  }
};

const listBanner = async () => {
  try {
    const config = 'social-event';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    if (bannerList.value.banner_image && bannerList.value.banner_image.trim() !== "") {
    image.value = `${base_url}${bannerList.value.banner_image}`;
    } else {
        image.value = ""; // or a default placeholder image path if you want
    }

   
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const toggleAccordion = (index) => {
    openIndex.value = openIndex.value === index ? null : index;
}
    
const truncateDescription = (text, limit) => {
    if (!text) return '';
    const stripped = text.replace(/<[^>]*>/g, '');
    return stripped.length > limit 
        ? stripped.substring(0, limit) + '...' 
        : stripped;
}

const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}
    

</script>

<style lang="scss" scoped>

.advert-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    padding: 20px 0;
}

.advert-card {
    background: white;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    transition: all 0.3s ease;
}

.advert-card:hover {
    border-color: #135422;
    box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.1);
}

.banner {
    width: 100%;
    height: 150px;
    background: #f3f4f6;
    position: relative;
    overflow: hidden;
}

.banner img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    transition: transform 0.5s ease;
}

.advert-card:hover .banner img {
    transform: scale(1.05);
}

.content {
    padding: 16px;
}

.category {
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.title {
    font-size: 13px;
    font-family:Comic Sans MS;
    font-weight: 700;
    color: #111827;
    line-height: 1.4;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.description {
    font-size: 12px;
    font-family:Comic Sans MS;
    color: #6b7280;
    line-height: 1.5;
    margin-bottom: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.website {
    font-size: 12px;
    font-family:Comic Sans MS;
    color: #6b7280;
    line-height: 1.5;
    margin-bottom: 15px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
}


.adverts-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 24px;
    padding: 0px 0;
}

.advert-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 350px;
    opacity: 1;
    border: 1px solid #0000001A;
    margin:8px;
    padding: 5px
}

.advert-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.advert-img {
    height: 200px;
    overflow: hidden;
}

.advert-img img {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    object-fit:fill;
    transition: transform 0.5s ease;
}

.event-card:hover .advert-img img {
    transform: scale(1.05);
}

.advert-content {
    padding: 20px;
}

.advert-content h2 {
    font-size: 12px;
    color: #4f46e5;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.advert-content h4 {
    font-size: 13px;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 12px;
    line-height: 1.3;
}

.advert-content p {
    color: #6b7280;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 15px;
}



.event-card {
  margin-bottom: 50px;
}

.event-card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

/* Make text take only needed space so image can push fully to the edge */
.blog-content {
  flex: 1;
}

.event-header {
  background: #139246;
  padding: 5px;
  color: #ffffff;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2{
        text-align: left;
        width: 100%;
        margin: 0 auto;          /* centers the <p> within its parent */
        word-wrap: break-word;   /* ensures long words wrap */
        overflow-wrap: break-word; /* modern equivalent */
        white-space: normal; 
        font-size: 18px !important;
    }
}

.arrow {
  transition: transform 0.3s ease;
}
.arrow.open {
  transform: rotate(180deg);
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.5s ease;
}
.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* Ensure image sits at extreme edge */
.blog-img {
  flex: 1;
  display: flex;
  justify-content: flex-end; /* This pushes image to the right */
}

.event-card-content:nth-child(odd) .blog-img {
  justify-content: flex-start; /* This pushes image to the left when index is odd */
}

.blog-img img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  object-fit: cover;
  display: flex;
  flex-direction: row;
  justify-content: right !important;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .event-card-content {
    flex-direction: column;
    text-align: center;
  }

  .blog-img {
    justify-content: right !important;
  }

  .blog-img img {
    max-width: 100%;
  }
}

.herosection {
    border-radius: 20px;
    background: #ffffff;
    background-size: cover;
    //height: 250px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 4rem 4rem;
}
.img-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.heroWriteup {
    display: flex;
    flex-direction: column;
    color: #000;

    h2 {
        font-size: 45px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        width: 80%;
        margin: 0 auto;          /* centers the <p> within its parent */
        word-wrap: break-word;   /* ensures long words wrap */
        overflow-wrap: break-word; /* modern equivalent */
        white-space: normal;     /* ensures wrapping happens */
    }
}
.imgsection{
    padding: 40px;
    img{
        width: 1140px;
        height: 620px;
        border-radius: 20px;
    }
}
.container{
    max-width: 1220px;
}

.event-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: auto;
    opacity: 1;
    border-radius: 20px;
    padding: 20px;
    border: 1px solid #0000001A;
    margin:8px
}

.blog-content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    opacity: 1;
    padding: 0 50px 0 0;

    h4{
        text-align: left;
        width: 100%;
        margin: 0 auto;          /* centers the <p> within its parent */
        word-wrap: break-word;   /* ensures long words wrap */
        overflow-wrap: break-word; /* modern equivalent */
        white-space: normal; 
    }
    p{
        text-align: left;
        width: 100%;
        margin: 0 auto;          /* centers the <p> within its parent */
        word-wrap: break-word;   /* ensures long words wrap */
        overflow-wrap: break-word; /* modern equivalent */
        white-space: normal; 
        
    }
}
.accordion-list {
    width: 100%;
    padding-top: 60px;
    padding-right: 80px;
    padding-bottom: 0px;
    padding-left: 80px;
    opacity: 1;
    border-radius: 40px;
    border-width: 1px;
}

.policy-title{
    font-size: 20px;
    line-height: 100%;
    text-align: left;
    margin-bottom: 50px;
}
.question-content{
    text-align: left;
}
.accordion-item {
    border-bottom: 1px solid #00000040;
    padding: 12px 0;
}

.accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-align: left;
}

.accordion-title {
    flex: 1;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    color: #000000;
    font-size: 18px;
}

.accordion-icon {
    width: 30px;
    height: 30px;
    transition: transform 0.2s ease;
}

.accordion-icon.rotated {
    transform: rotate(180deg);
}

.accordion-content {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    text-align: left;
}

/* Smooth open/close transition */
.accordion-enter-active,
.accordion-leave-active {
    transition: max-height 0.25s ease, opacity 0.2s ease;
}

.accordion-enter-from,
.accordion-leave-to {
    max-height: 0;
    opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
    max-height: 200px;
    opacity: 1;
}

@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

    }

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }



    .heroWriteup {
        position: absolute;
        width: 100%;
        text-align: left;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 28px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 14px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #7c7777;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 15px 25px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }

    .imgsection{
        margin-top: 15px;
        padding: 0px;
        img{
            width: 100%;
            height: 620px;
            border-radius: 20px;
        }
    }
}

.card {
    max-width: 100%;
    margin: 1rem auto;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #ffffff;
    border-radius: 40px;
    border: 1px solid #00000033;
    padding: 10px 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
